import React, { Component } from 'react';
import { UserRole } from '../reducers/AuthRdc';
import { withRouter } from 'react-router';
import { RBACProps } from '../connected/RBACCnn';
import HomeRestaurantCnn from '../../Home/connected/HomeRestaurantCnn';
import HomeSupplierCnn from '../../Home/connected/HomeSupplierCnn';
import AdminHome from '../../Home/components/Admin/AdminHome';

class RBAC extends Component<RBACProps> {
    getDefaultViewForRole = (role: UserRole) => {
        if (role === "Restaurant")
            return (<HomeRestaurantCnn />)
        else if (role === "Supplier")
            return (<HomeSupplierCnn />)
        else if (role === "Administrator")
            return (<AdminHome/>)
        else
            return (<div>Unsupported role</div>)
    }

    componentWillMount() {
        if (this.props.for && this.props.for !== this.props.currentUserRole)
            this.props.history.push('/')
    }

    render() {
        return (
            <div>
                {this.props.getDefaultView === true ?
                    <div>
                        {this.getDefaultViewForRole(this.props.currentUserRole)}
                    </div>
                    :
                    <div>
                        {this.props.for === this.props.currentUserRole &&
                            <div>
                                {this.props.children}
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(RBAC);